import { AuthServices } from '@/features/auth/services';
import { auth } from '@/features/auth/types';

/** Body for POST /api/v1/guardians/me/favorite-coaches (`AddFavoriteCoachesRequestDto`). */
export type AddFavoriteCoachesRequest = auth.AddFavoriteCoachesRequest;

/** A saved favorite coach, from the favorite-coaches endpoint (`FavoriteCoachResponseDto`). */
export type FavoriteCoach = auth.FavoriteCoachResponse;

/**
 * Saves one or more coaches as favorites of the signed-in guardian via
 * POST `/api/v1/guardians/me/favorite-coaches`; returns the saved favorites.
 */
export async function addFavoriteCoaches(
  data: AddFavoriteCoachesRequest,
): Promise<FavoriteCoach[]> {
  return await AuthServices.addFavoriteCoaches(data);
}
